import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      padding: theme.spacing(2),
    },
    icons: {
      marginTop: -theme.spacing(2),
    },
    title: {
      fontSize: 32,
      fontWeight: 'normal',
      lineHeight: '44px',
    },
    subtitle: {
      marginBottom: theme.spacing(3),
    },
    card: {
      minHeight: 80,
      background: '#F5F8FA',
      borderRadius: 20,
      '&:not(:last-child)': {
        marginRight: theme.spacing(1),
      },
      padding: theme.spacing(0.5, 2),
    },
    mapBox: {
      margin: theme.spacing(3, 0),
      [theme.breakpoints.between('sm', 'md')]: {
        height: 520,
      },
      [theme.breakpoints.between('md', 'lg')]: {
        height: 570,
      },
      [theme.breakpoints.up('xl')]: {
        height: 720,
      },
    },
    leafletMap: {
      height: '100%',
      width: '100%',
      borderRadius: '10px 10px 0px 0px',
    },
    tableContainer: {
      marginTop: theme.spacing(6),
    },
    table: {
      '& th:first-child': {
        borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },
      '& table': {
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: '10px 0px 10px 10px',
        '&:last-child': {
          paddingRight: 15,
        },
        '&:first-child': {
          paddingLeft: 30,
        },
      },
      '& tbody tr > *': {
        padding: '0px 10px',
        '&:first-child': {
          paddingLeft: 30,
        },
      },
      '& td': {
        borderBottom: 'none',
        '&:first-child': {
          '& > div': {
            padding: '0px 0px 0px 30px',
          },
        },
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
        height: 40,
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
        height: 40,
      },
    },
    overwritePd: {
      padding: theme.spacing(2),
    },
    goMapLink: {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
    icon: {
      '& > *': {
        fill: 'rgba(0, 0, 0, 0.54)',
      },
    },
    tabs: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      borderBottom: '1px solid #ddd',
    },
    infoContainer: {
      width: '90%',
      marginTop: theme.spacing(4),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    infoText: {
      fontSize: 20,
    },
    linePrefix: {
      width: 100,
      heigth: 40,
      color: theme.palette.colors.white,
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'center',

      borderRadius: 5,
      padding: theme.spacing(0.1),
      marginRight: theme.spacing(1),
    },
    photosContainer: {
      marginTop: theme.spacing(2),
    },
    accordion: {
      width: '100%',
      '& .MuiAccordionDetails-root': {
        padding: '0px 16px 16px',
      },
    },
    occurrenciesContainer: {
      width: '95%',
      marginTop: theme.spacing(4),
      marginLeft: theme.spacing(4),
    },
    cardText: {
      fontSize: 20,
    },
    imageContainer: {
      width: 200,
      height: 100,
      overflow: 'hidden',

      '&:hover': {
        cursor: 'pointer',
      },
    },
    imageContainerDisabled: {
      width: 200,
      height: 100,
      overflow: 'hidden',
    },
    askMissingEntries: {
      textTransform: 'none',
      borderRadius: 12,
      background: '#0094FF',
      color: '#FFFFFF',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    contentImages: {
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(170, 184, 194, 0.8);',
        borderRadius: 15,
      },
      scrollbarWidth: 'thin',
      msOverflowStyle: 'auto',
    },
  }),
);

export default useStyles;
